
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import YouTube from "react-youtube";
import GeogebraDraw from "../../components/GeogebraDraw";
import IfPaidUser from "../../components/IfPaidUser";
import "../../markdown-styles/styles.css";
import Content from "../../components/Content";
import Container from "../../components/Layouts/Container";
import ContentTextBoxes from "../../components/Layouts/ContentTextBoxes";
import PutsLongShort from "../../components/Pdf/Puts_Long_Short";
export const meta = {
  title: " This is my Title2",
  chapter: "Chapter1",
  ispublished: true,
  date: "21 dec 2021",
  author: "Pavan Kumaar Mirla"
};
export const ggbParameters = {
  // material_id: "",
  // width: 1800,
  // height: 950,
  borderColor: "#1E1e1E",
  enableShiftDragZoom: false,
  showToolBar: false
};
export const opts = {
  height: '390',
  width: '510',
  playerVars: {
    // https://developers.google.com/youtube/player_parameters
    autoplay: 1
  }
};
export const Box1 = () => <div style={{
  padding: 20,
  backgroundColor: 'tomato'
}}>
    <YouTube videoId="-EQO6YMIzqg" opts={opts} mdxType="YouTube" />
  </div>;
export const Box2 = () => <div style={{
  padding: 20,
  backgroundColor: 'green'
}} />;
export const DefaultBox = () => <div style={{
  padding: 20,
  backgroundColor: 'yellow'
}} />;
export const Text4 = () => <div style={{
  padding: 20,
  backgroundColor: 'tomato'
}}>
    <YouTube videoId="Wt827RAJHaY" opts={opts} mdxType="YouTube" />
  </div>;
export const componetArray = [<DefaultBox mdxType="DefaultBox" />, <Box1 mdxType="Box1" />, <Box2 mdxType="Box2" />];
export const indexArray = {
  button1: 1,
  text14: 1
};
export const items1 = [{
  title: 'What is meant by exercising a Put option?',
  subtitle: "The holder of a Put option can sell 100 shares of a stock at a specific price within a specified period of time."
}, {
  title: 'When will Put holder exercise his Put?',
  subtitle: 'If the premium for the Put option in the market is higher than the price at which the Put was bought'
}, {
  title: 'Can the Put holder sell the Put before it expires?',
  subtitle: 'Yes, if the market pays him higher than his purchase price'
}, {
  title: 'Who coordinates the exercise of options and delivery of stock?',
  subtitle: "The Options Clearance Corporation."
}, {
  title: 'Auto exercise',
  subtitle: 'According to Options Clearing Corporation (OCC) rules, any contract that is ITM at expiration is subject to auto-exercise. '
}];
export const items2 = [{
  title: 'Non linear option payoff',
  subtitle: " Before maturity, the premium is not linearly influenced by volatility, time, the stock value, and interest rates. This is a result of Black Scholes pricing."
}, {
  title: 'Effect of volatility on long Put option premium',
  subtitle: 'Volatility and option premium are positively correlated. In other words, as volatility increases, option premiums increase. When volatility decreases, option premiums decrease. '
}, {
  title: 'Effect of time to expiry on long Put option premium',
  subtitle: 'Time left to expire and option premiums are negatively correlated. Thus, as time moves towards maturity, option premiums decrease. As the expiration date approaches, option premiums decrease. '
}];
export const Box11 = () => <div style={{
  padding: 20,
  backgroundColor: 'tomato'
}}>
    <YouTube videoId="FAwDrUqpGUI" opts={opts} mdxType="YouTube" />
  </div>;
export const Box22 = () => <div style={{
  padding: 20,
  backgroundColor: 'tomato'
}}>
    <YouTube videoId="Wt827RAJHaY" opts={opts} mdxType="YouTube" />
  </div>;

const layoutProps = {
  meta,
ggbParameters,
opts,
Box1,
Box2,
DefaultBox,
Text4,
componetArray,
indexArray,
items1,
items2,
Box11,
Box22
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">










    <h1>{`EXTRINSIC VALUE oF A LONG PUT`}</h1>

    <Container mdxType="Container">
  <Content items={items1} title={"Basics"} mdxType="Content" />
    </Container>
    <h1>{`summary poster`}</h1>
    <PutsLongShort mdxType="PutsLongShort" />
    <h1>{`Interactive`}</h1>
  <GeogebraDraw jsonUrl="https://storage.googleapis.com/chapters-ifm/testfolder/2022/BASICS/puts_long_and_short_ev.json" ggbParameters={ggbParameters} appId="id_speculator_put" email="pavanmirla@gmail.com" data={[{
      component: <Box1 mdxType="Box1" />,
      button: "button1"
    }, {
      component: <Box2 mdxType="Box2" />,
      button: "text14"
    }, {
      component: <Text4 mdxType="Text4" />,
      button: "text4"
    }]} mdxType="GeogebraDraw" />

    <Container mdxType="Container">
  <Content items={items2} title={"Here are the main points to remember"} mdxType="Content" />
    </Container>


    <p><a parentName="p" {...{
        "href": "https://www.reddit.com/r/options/comments/lt8d68/i_bought_a_deep_itm_put_am_i_an_idiot/"
      }}>{`https://www.reddit.com/r/options/comments/lt8d68/i_bought_a_deep_itm_put_am_i_an_idiot/`}</a></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;